import React, { useEffect } from "react";
import { loadTermlyScript } from "./termly_script";

const EMBED_DATA_ID = "c69ef119-5bb3-4131-b6f1-caa3551e5894";

export function ReturnPolicyRender(): React.ReactElement {
  useEffect(() => {
    loadTermlyScript();
  }, []);

  const divProps: React.HTMLAttributes<HTMLDivElement> & { name: string; "data-id": string } = {
    name: "termly-embed",
    "data-id": EMBED_DATA_ID,
  };
  return <div {...divProps} />;
}
